import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicy = () => (
  <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
    <header className="bg-[#0a1a3d] py-5">
      <div className="max-w-[900px] mx-auto px-4 sm:px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 no-underline">
          <div className="w-8 h-8 bg-[#0E47B0] rounded-md flex items-center justify-center">
            <span className="text-white font-bold text-sm">L</span>
          </div>
          <span className="text-white font-bold text-lg">Lex Recupero</span>
        </Link>
        <Link to="/" className="text-white/60 hover:text-white text-sm no-underline transition-colors">&larr; Torna alla home</Link>
      </div>
    </header>

    <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-12">
      <h1 className="text-[32px] font-bold text-[#1a1a2e] mb-8">Cookie Policy</h1>
      <p className="text-sm text-[#4a4a6a] mb-6">Ultimo aggiornamento: Aprile 2026</p>

      <div className="space-y-6 text-[15px] text-[#4a4a6a] leading-[1.8]">
        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">1. Cosa sono i cookie</h2>
          <p>I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo quando visiti un sito web. Vengono utilizzati per migliorare la tua esperienza di navigazione e per fornire informazioni ai proprietari del sito.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">2. Cookie che utilizziamo</h2>
          <p>Utilizziamo i seguenti tipi di cookie:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li><strong>Cookie tecnici:</strong> Necessari per il funzionamento del sito e non possono essere disattivati.</li>
            <li><strong>Cookie analitici:</strong> Ci aiutano a capire come i visitatori interagiscono con il sito, raccogliendo informazioni in forma anonima.</li>
            <li><strong>Cookie di marketing:</strong> Utilizzati per ottimizzare le campagne di acquisizione (es. Meta Pixel).</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">3. Cookie di terze parti</h2>
          <p>Il nostro sito potrebbe utilizzare cookie di terze parti, tra cui:</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li>Meta Pixel (Facebook) per la misurazione delle conversioni pubblicitarie</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">4. Gestione dei cookie</h2>
          <p>Puoi gestire le preferenze sui cookie attraverso le impostazioni del tuo browser. Tieni presente che la disabilitazione di alcuni cookie potrebbe influire sulla funzionalità del sito.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">5. Aggiornamenti</h2>
          <p>Questa Cookie Policy potrebbe essere aggiornata periodicamente. Ti consigliamo di controllare regolarmente questa pagina per eventuali modifiche.</p>
        </section>
      </div>
    </div>
  </div>
);

export default CookiePolicy;
